// Constants
import { GIL_API_CHANNEL } from 'constants/api.constants';
// Enumerations
import { IdentificationStatusEnumeration } from 'enumerations/identification-status.enumeration';
// Utilities
import { getCheckoutIdFromUrl } from 'utils/browser-url.utils';

const COMMON_INCOME_SERVICE_CONFIGURATION = {
  endpoint:
    'gil-api-mng-amz-ldg/v1/checkout/orders/:checkoutId/identification/:identificationId/openbanking/complete',
  pathParams: {
    checkoutId: getCheckoutIdFromUrl(),
  },
  ...GIL_API_CHANNEL,
};

const COMPLETE_OPENBANKING_SERVICE_CONFIGURATION = {
  ...COMMON_INCOME_SERVICE_CONFIGURATION,
  params: {
    status: IdentificationStatusEnumeration.ACCEPTED,
  },
};

const INVALIDATE_OPENBANKING_SERVICE_CONFIGURATION = {
  ...COMMON_INCOME_SERVICE_CONFIGURATION,
  params: {
    status: IdentificationStatusEnumeration.REJECTED,
  },
};

export { COMPLETE_OPENBANKING_SERVICE_CONFIGURATION, INVALIDATE_OPENBANKING_SERVICE_CONFIGURATION };
